import { createContext, useCallback, useContext, useMemo } from "react";
import { Enums } from "../enums";
import LocalStorageService from "../services/local/localStorageService/LocalStorageService";

export type UiPreference = "classic" | "new";

interface UiPreferenceContextValue {
  preference: UiPreference;
  setPreference: (pref: UiPreference) => void;
}

const UiPreferenceContext = createContext<UiPreferenceContextValue | null>(null);

function redirectToNew() {
  const currentPath = window.location.pathname.replace(/^\/insight\//, "/insights/");
  window.location.href = window.location.origin + currentPath + window.location.search;
}

export const UiPreferenceProvider: React.FC<ReactProps> = ({ children }) => {
  const stored = LocalStorageService.get(Enums.LocalCookies.UI_PREFERENCE) as string | null;

  const setPreference = useCallback((pref: UiPreference) => {
    LocalStorageService.set(Enums.LocalCookies.UI_PREFERENCE, pref);
    debugger;
    if (pref === "new") {
      redirectToNew();
    }
  }, []);

  const preference: UiPreference = (stored as UiPreference) ?? "classic";

  const value = useMemo(() => ({ preference, setPreference }), [preference, setPreference]);

  // If preference is classic, redirect immediately and don't render children
  if (stored === "new") {
    redirectToNew();
    return null;
  }

  return <UiPreferenceContext.Provider value={value}>{children}</UiPreferenceContext.Provider>;
};

export function useUiPreference(): UiPreferenceContextValue {
  const ctx = useContext(UiPreferenceContext);
  if (!ctx) {
    throw new Error("useUiPreference must be used within a UiPreferenceProvider");
  }
  return ctx;
}
